import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Programacao from "@/pages/Programacao";
import Atividade from "@/pages/Atividade";
import MinhaFeira from "@/pages/MinhaFeira";
import Mapa from "@/pages/Mapa";
import Organizacoes from "@/pages/Organizacoes";
import Organizacao from "@/pages/Organizacao";
import Semana from "@/pages/Semana";
import Iniciativa from "@/pages/Iniciativa";
import SaudeMental from "@/pages/SaudeMental";
import Noticias from "@/pages/Noticias";
import Noticia from "@/pages/Noticia";
import Galeria from "@/pages/Galeria";
import Info from "@/pages/Info";
import PageView from "@/pages/PageView";
import Pesquisa from "@/pages/Pesquisa";
import Agora from "@/pages/Agora";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminCollection from "@/admin/AdminCollection";
import AdminUsers from "@/admin/AdminUsers";
import AdminSettings from "@/admin/AdminSettings";

export default function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="utilizadores" element={<AdminUsers />} />
              <Route path="definicoes" element={<AdminSettings />} />
              <Route path=":collection" element={<AdminCollection />} />
            </Route>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/programacao" element={<Programacao />} />
              <Route path="/atividade/:slug" element={<Atividade />} />
              <Route path="/a-minha-feira" element={<MinhaFeira />} />
              <Route path="/agora" element={<Agora />} />
              <Route path="/mapa" element={<Mapa />} />
              <Route path="/organizacoes" element={<Organizacoes />} />
              <Route path="/organizacoes/:slug" element={<Organizacao />} />
              <Route path="/semana" element={<Semana />} />
              <Route path="/semana/:slug" element={<Iniciativa />} />
              <Route path="/saude-mental" element={<SaudeMental />} />
              <Route path="/noticias" element={<Noticias />} />
              <Route path="/noticias/:slug" element={<Noticia />} />
              <Route path="/galeria" element={<Galeria />} />
              <Route path="/memoria" element={<PageView slug="memoria" />} />
              <Route path="/informacoes" element={<Info />} />
              <Route path="/privacidade" element={<PageView slug="privacidade" />} />
              <Route path="/cookies" element={<PageView slug="cookies" withConsent />} />
              <Route path="/pesquisa" element={<Pesquisa />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}
